<template>
  <div>
    <h1 class="text-2xl font-bold mb-4">Echoués</h1>
    <Alert>
      Lorsqu’un prélèvement SEPA échoue (par exemple pour cause de refus par la banque, compte clos ou fonds
      insuffisants), la vente associée est annulée. Les échecs sont recensés dans ce tableau, accompagnés du motif
      fourni par la banque.
    </Alert>
    <LeadsList status="payment_intent_failed" :noDataMsg="$t('NoLeadFailed')" />
  </div>
</template>

<script>
import { Alert } from "@estaly/ui";
import LeadsList from "@/components/leads/LeadsList.vue";

export default {
  components: {
    Alert,
    LeadsList,
  },
};
</script>
